import { useEffect, useEffectEvent } from "react";

export const useKeyboard = (
  callback: (e: KeyboardEvent) => void,
  key: KeyboardEvent["key"],
) => {
  const onKeyDown = useEffectEvent((e: KeyboardEvent) => {
    if (e.key !== key) return;
    callback(e);
  });

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [key]);
};
